<template>
  <tr>
    <td>{{ item.rno }}</td>
    <td>{{ item.wadatIst }}</td>
    <td>{{ item.ztransDate }}</td>
    <td>{{ item.orderDt }}</td>
    <td>{{ item.orderNo }}</td>
    <td>{{ item.sapOrderNo }}</td>
    <td>{{ item.vbelnLf }}</td>
    <td>{{ item.matnr }}</td>
    <td class="al">{{ item.zzmaktx }}</td>
    <td>{{ item.zztotalQty }}</td>
    <td>{{ Number(item.kwmeng) }}</td>
    <td>{{ Number(item.lfimg) }}</td>
    <td>{{ Number(item.canQty) }}</td>
    <td>{{ Utils.replace(item.namePlant, "노루페인트", "") }}</td>
    <td>
      <template
        v-if="
          item.dlvMthdCd == 10 || item.dlvMthdCd == 15 || item.dlvMthdCd == 25
        "
      >
        {{ item.addr }}
      </template>
      <template v-if="item.dlvMthdCd == 20">
        {{ item.dlvBranchCd }}
      </template>
      <template v-if="item.dlvMthdCd == 30">
        {{ Utils.replace(item.namePlant, "노루페인트", "") }}
      </template>
    </td>
    <td>{{ item.bname }}</td>
    <td>{{ item.telf1 }}</td>
    <td>
      <div>
        <span class="c-util-button type-line-gray type-small type-round">
          <span>{{ item.dlvMthdNm }}</span>
        </span>
      </div>
    </td>
    <td>{{ item.zphone }}</td>
    <td>{{ item.carNo }}</td>
  </tr>
</template>
<script setup>
import { defineProps, ref } from "vue";
import Utils from "@/js/utils";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
});

const item = ref(props.item);
</script>
